module.exports = __webpack_public_path__ + "img/17_56.8ec7d21f.png";